// src/services/NotificationService.js
import * as signalR from "@microsoft/signalr";

const connection = new signalR.HubConnectionBuilder()
    .withUrl("https://redevz.com/notificationHub", {
    accessTokenFactory: () => localStorage.getItem("token")
})
    .withAutomaticReconnect()
    .build();

const startConnection = async () => {
    try {
       
        await connection.start();
        console.log("SignalR Connected.");
    } catch (err) {
        console.error("SignalR Connection Error: ", err);
        setTimeout(() => startConnection(), 50000);
    }
};

const onReceiveNotification = (callback) => {
    connection.on("ReceiveNotification", (message) => {
        callback(message);
    });
};

export default {
    startConnection,
    onReceiveNotification
};
